(function () {
  document.querySelectorAll('.srvp[data-srvp]').forEach((root) => {
    if (root.dataset.ready) return; root.dataset.ready = '1';
    const inDrop = root.dataset.inDrop === 'true';
    const pct = root.dataset.pct || '20';
    const title = root.dataset.title || '';
    const addFn = (items, label, nudge) => window.srvAdd ? window.srvAdd(items, label, nudge) : Promise.resolve(false);
    const add = root.querySelector('[data-add]');
    const stickyAdd = root.querySelector('[data-sticky-add]');
    const priceEl = root.querySelector('[data-price]');
    const stickyPrice = root.querySelector('[data-sticky-price]');
    const stock = root.querySelector('[data-stock]');

    const setVariant = (b, updateUrl) => {
      root.querySelectorAll('.srvp__size').forEach((x) => { x.classList.toggle('is-on', x === b); x.setAttribute('aria-checked', x === b); });
      add.dataset.variant = b.dataset.variant;
      priceEl.textContent = b.dataset.price; if (stickyPrice) stickyPrice.textContent = b.dataset.price;
      let cmp = root.querySelector('[data-compare]');
      if (b.dataset.compare) { if (!cmp) { cmp = document.createElement('s'); cmp.setAttribute('data-compare', ''); priceEl.after(cmp); } cmp.textContent = b.dataset.compare; } else if (cmp) cmp.remove();
      const q = +b.dataset.qty;
      stock.textContent = b.dataset.tracked && q > 0 && q <= 3 ? 'Only ' + q + ' left in this size' : '';
      if (updateUrl) { const u = new URL(location.href); u.searchParams.set('variant', b.dataset.variant); history.replaceState(null, '', u); }
    };
    root.querySelectorAll('.srvp__size').forEach((b) => b.addEventListener('click', () => setVariant(b, true)));
    const on = root.querySelector('.srvp__size.is-on'); if (on) setVariant(on, false);

    const doAdd = async () => {
      if (!add.dataset.variant || add.disabled) return;
      add.classList.add('is-busy');
      await addFn([{ id: +add.dataset.variant, quantity: 1 }], title + ' added', inDrop);
      add.classList.remove('is-busy');
    };
    add.addEventListener('click', doAdd);
    if (stickyAdd) stickyAdd.addEventListener('click', doAdd);

    root.querySelectorAll('[data-quick-add]').forEach((b) => b.addEventListener('click', async () => {
      b.classList.add('is-busy');
      await addFn([{ id: +b.dataset.quickAdd, quantity: 1 }], b.dataset.label + ' added · ' + pct + '% off applies with 2 pieces');
      b.classList.remove('is-busy');
    }));

    const slides = root.querySelector('[data-slides]'), dots = root.querySelectorAll('[data-dots] span');
    if (slides && dots.length) slides.addEventListener('scroll', () => {
      const i = Math.round(slides.scrollLeft / slides.clientWidth);
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    }, { passive: true });

    const sticky = root.querySelector('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) new IntersectionObserver(([e]) => {
      const show = !e.isIntersecting && e.boundingClientRect.top < 0;
      sticky.classList.toggle('is-on', show); sticky.setAttribute('aria-hidden', !show); stickyAdd.tabIndex = show ? 0 : -1;
    }).observe(add);

    const sheet = root.querySelector('[data-sheet]');
    if (sheet) {
      root.querySelectorAll('[data-open-sheet]').forEach((b) => b.addEventListener('click', () => { sheet.hidden = false; }));
      root.querySelectorAll('[data-close-sheet]').forEach((b) => b.addEventListener('click', () => { sheet.hidden = true; }));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') sheet.hidden = true; });
    }
  });
})();
